module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setGoogleJsonCredentialsCard.title":"Set Google Credentials","setGoogleJsonCredentialsCard.subtitle":"Google Cloud Platform JSON credentials","setGoogleJsonCredentialsCard.jsonCredentials":"Json Credentials","setGoogleJsonCredentialsCard.dataSetId":"Dataset ID","setGoogleJsonCredentialsCard.tableId":"Table ID"}}')
  delete Component.options._Ctor
}
